module.exports = __webpack_public_path__ + "img/at-work.6119b339.svg";